import React from 'react';
import {
  Box,
  Controller,
  FlexPercentField,
  PriceInput,
  RegularField,
  Text,
  useFormContext,
} from '@common-fe/common-fe';

import { REGEXPS } from '@/common';
import { RenewalPaymentRule } from '@/modules/Renewals/renewals.types';

import { EditAmountsFormValues } from '../EditAmountsModal.types';

interface Props {
  rule: RenewalPaymentRule;
  ruleIndex: number;
  tierIndex: number;
  serviceIndex: number;
  isPercentageType: boolean;
  testId?: string;
}

const PaymentRuleField: React.FC<Props> = ({
  rule,
  ruleIndex,
  tierIndex,
  serviceIndex,
  isPercentageType,
  testId = 'edit-amounts-modal',
}) => {
  const { control } = useFormContext<EditAmountsFormValues>();

  return (
    <Box key={`${rule.planName}-${ruleIndex}`} gap="spacing4">
      <Text weight={700} color="textBody">
        Payment Rule {ruleIndex + 1}
      </Text>
      <Box direction="row" gap="spacing12" align="start">
        <Box width="50%">
          <Text color="textBody" margin={{ bottom: 'spacing8' }}>
            Account to pay from
          </Text>
          <RegularField
            testId={`${rule?.planName}_name-input`}
            name={`${rule?.planName}_name-input`}
            value={rule?.planName || ''}
            placeholder="Processing rule name"
            disabled
            editMode
            onChange={() => {}}
          />
        </Box>
        <Box width="50%">
          <Text color="textBody" margin={{ bottom: 'spacing8' }}>
            {isPercentageType ? 'Percentage to pay' : 'Amount to pay'}
          </Text>
          <Controller
            name={`tiers.${tierIndex}.services.${serviceIndex}.paymentRules.${ruleIndex}.amount`}
            control={control}
            render={({ field, fieldState }) =>
              isPercentageType ? (
                <FlexPercentField
                  testId={`${testId}_tier-${tierIndex}_service-${serviceIndex}_rule-${ruleIndex}_percentage`}
                  name={field.name}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Enter percentage to pay from"
                  editMode
                  regexp={REGEXPS.INTEGER_PERCENT}
                  errorText={fieldState.error?.message}
                />
              ) : (
                <PriceInput
                  testId={`${testId}_tier-${tierIndex}_service-${serviceIndex}_rule-${ruleIndex}_amount`}
                  name={field.name}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Enter amount to pay from"
                  errorText={fieldState.error?.message}
                />
              )}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentRuleField;
